import { Card, Link, PencilIcon } from '@rulebooks/evidend-titan';
import { t, Trans } from '@lingui/macro';
import { SidebarFormContainer, SidebarFormContent } from 'components/SidebarForm/SidebarForm';
import { setFormErrors } from 'forms/helpers/setFormErrors';
import type { LegalEntityForeignGeneralInfoFormValues } from 'forms/legal-entity/LegalEntityForeignGeneralInfoForm';
import {
  LegalEntityForeignGeneralInfoForm,
  legalEntityForeignGeneralInfoFormSchema,
} from 'forms/legal-entity/LegalEntityForeignGeneralInfoForm';
import { PartyUpdateForm, partyUpdateFormSchema } from 'forms/PartyUpdateForm';
import { useUpdateLegalEntityMutation, type LegalEntity } from 'generated/gql';
import { mapLegalEntityToLegalEntityInput } from 'graphql/input-mappers/LegalEntity';
import { useGlobalError } from 'hooks/useGlobalError';
import { useState } from 'react';

interface IForeignSidebarLink {
  legalEntity: LegalEntity;
}

export const ForeignSidebarLink = ({ legalEntity }: IForeignSidebarLink) => {
  const [, setGlobalError] = useGlobalError();
  const [updateLegalEntity] = useUpdateLegalEntityMutation();
  const [isFormDrawerShown, setFormDrawerShown] = useState<boolean>(false);

  const formSchema = legalEntityForeignGeneralInfoFormSchema.concat(partyUpdateFormSchema({}));
  return (
    <>
      <SidebarFormContainer isDrawerShown={isFormDrawerShown}>
        <SidebarFormContent
          defaultValues={legalEntity as LegalEntityForeignGeneralInfoFormValues}
          form={
            <>
              <LegalEntityForeignGeneralInfoForm hasColumns={false} />
              <Card backgroundVariant="grey">
                <PartyUpdateForm isFoundation={legalEntity.isFoundation} />
              </Card>
            </>
          }
          formSchema={formSchema}
          header={t`Gegevens wijzigen`}
          setDrawerClosed={() => setFormDrawerShown(false)}
          onSubmit={({ date, reason, tradeRegisterNumber, name, countryOfRegistration }, form) => {
            const legalEntityInput = mapLegalEntityToLegalEntityInput({
              ...legalEntity,
              tradeRegisterNumber,
              name,
              countryOfRegistration,
            });
            updateLegalEntity({
              variables: {
                legalEntityId: legalEntity.id,
                legalEntity: legalEntityInput,
                effectiveDate: date,
                reason,
              },
              onCompleted: () => {
                setFormDrawerShown(false);
              },
              onError: ({ graphQLErrors }) => {
                setFormErrors({
                  errors: graphQLErrors,
                  form,
                  setGlobalError,
                });
              },
            });
          }}
        />
      </SidebarFormContainer>

      <Link prefixAdornment={<PencilIcon />} onClick={() => setFormDrawerShown(true)}>
        <Trans>Wijzig</Trans>
      </Link>
    </>
  );
};
